import React, { forwardRef } from "react";
import { Modal } from "@clarkinc/zest-design-system";
import ZestVideoModal from "~/common/VideoModal/ZestVideoModal";

interface Props {
  youTubeVideoId?: string;
}

const CareersVideo = forwardRef<HTMLDivElement, Props>(
  ({ youTubeVideoId = "xCbkCcuyvHY" }, ref) => {
    const onClickPlay = () => Modal.toggle("zestVideoModal");

    return (
      <>
        <div className="careers-video" ref={ref}>
          <div className="careers-video-content">
            <div className="careers-video-play">
              <button
                type="button"
                className="careers-video__play-btn"
                onClick={onClickPlay}
              >
                <span className="sr-only">Play Video</span>
              </button>
            </div>
            <div className="careers-video-text">
              <div className="careers-section-title">Why</div>
              <h2 className="careers-video__title">Start Your Career</h2>
              <p className="careers-video__text">
                Energetic coworkers, a hand in decisions and development, and
                opportunities to move up ensure that you will love working here.
                See why our employees are happy!
              </p>
            </div>
          </div>
        </div>
        <ZestVideoModal
          video={{
            youtubeId: youTubeVideoId,
            poster: "",
            sources: {
              high: "",
              medium: "",
              low: "",
              ipad: "",
              product: "",
            },
            videoPath: "",
            isModelingVideo: false,
          }}
        />
      </>
    );
  }
);

export default CareersVideo;
